module.exports = __webpack_public_path__ + "static/media/Edge-ConneX.544bd1f3.png";